import {
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import {
  CreateCommentRequestPayload,
  EditCommentRequestPayload,
  SaveRatingRequestPayload,
  UserComment,
} from '../../types'

export type GetCommentsQueryPaylod = {
  user_id?: string
  limit?: string
  context_id?: string
  context_type?: string
}

export const commentsApi = createApi({
  reducerPath: 'commentsApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Comments'],
  endpoints: (builder) => ({
    getComments: builder.query<UserComment[], GetCommentsQueryPaylod>({
      query: (query: GetCommentsQueryPaylod) => ({
        url: generateUrl(query),
      }),
      providesTags: ['Comments'],
    }),
    getCommentsByContextId: builder.query<
      UserComment[],
      GetCommentsQueryPaylod
    >({
      query: (query: GetCommentsQueryPaylod) => ({
        url: generateUrl(query),
      }),
      providesTags: ['Comments'],
    }),
    createComment: builder.mutation({
      query: (payload: CreateCommentRequestPayload) => {
        const enhancedComment = {
          ...payload,
          comment: payload.comment,
        }
        return {
          url: CONSTANTS.API.COMMENTS,
          method: 'POST',
          body: enhancedComment,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
      invalidatesTags: ['Comments'],
    }),
    saveCommentRating: builder.mutation({
      query: (payload: SaveRatingRequestPayload) => {
        return {
          url: `${CONSTANTS.API.COMMENTS}/${payload.comment_id}${CONSTANTS.API.RATINGS}`,
          method: 'POST',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
    editComment: builder.mutation({
      query: (payload: EditCommentRequestPayload) => {
        return {
          url: `${CONSTANTS.API.COMMENTS}/${payload.id}`,
          method: 'PATCH',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
  }),
})

const generateUrl = (queryParams: GetCommentsQueryPaylod) => {
  let query = new URLSearchParams(queryParams).toString()
  query = query.replace('undefined', '')
  return `${CONSTANTS.API.COMMENTS}${query.length > 0 ? '?' : ''}${query}`
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCommentsQuery,
  useGetCommentsByContextIdQuery,
  useCreateCommentMutation,
  useSaveCommentRatingMutation,
  useEditCommentMutation,
} = commentsApi
